import React from "react"
import cx from "classnames"

import styles from "./sideTitle.module.scss"

export default function SideTitle({ title, className }) {
  if (!title) {
    return null
  }

  return <div className={cx(styles.sideTitle, className)}>{title}</div>
}
